module.exports = __webpack_public_path__ + "static/img/phoneContent.5de7fbdc.png";